import React from 'react';
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton
} from '@chakra-ui/react';

export default function ConfirmationModal(props) {
    const { isOpen, onClose, onActionConfirm, modalBody, title, successText , children } = props;
    const handleSubmit = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const values = Object.fromEntries(formData.entries());
        onActionConfirm(values);
    };
    return (
        <Modal isOpen={isOpen} onClose={onClose}>

            <ModalOverlay />
            <ModalContent>
                <form onSubmit={handleSubmit} >

                    <ModalHeader>{ title || 'Confirm Action'}</ModalHeader>

                    <ModalCloseButton />
                    <ModalBody>
                        {modalBody}
                        { children}
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="ghost" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button colorScheme="red" type='submit' mr={3} >
                            { successText || 'Yes'}
                        </Button>

                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}
